import { ReactElement, memo } from "react";

import { displayCentsWithDollarSign } from "../../../../common/helpers/stringUtils";
import Condition from "../../../../components/Conditional/Condition";
import I18nText from "../../../../components/I18nText/I18nText";

interface IProps {
	title: string;
	title_cn: string;
	price: number;
}

const CustomizationOptionDisplay = ({ title, title_cn, price }: IProps): ReactElement => {
	return (
		<div className="OptionDisplay">
			<div className="Label">
				<I18nText enText={title} cnText={title_cn} />
			</div>
			<div className="Price">
				<Condition check={price > 0}>{`+ ${displayCentsWithDollarSign(price)}`}</Condition>
			</div>
		</div>
	);
};

export default memo(CustomizationOptionDisplay);
